import { createSimpleStaleWhileRevalidateOperation, } from '@office-start/persistence-strategies';
import { readFromSimplePersistence, writeToSimplePersistence, } from '@office-start/simple-persistence';
import { getMyDriveInfo } from '../operations/getMyDriveInfo';
var oneDriveInfoPersistenceKey = 'oneDriveInfo';
var oneDriveInfoPersistenceVersion = 1;
export function executeMyDriveInfoDataFlow(officeComponentContext, identity, sharedContext, handleRevalidation) {
    var options = {
        graphApiRoot: sharedContext.graphApiRoot,
        correlationId: officeComponentContext.correlationId,
        getAccessToken: officeComponentContext.getAccessToken,
        jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
        officeApiRoot: officeComponentContext.officeHomeApiRoot,
    };
    return createSimpleStaleWhileRevalidateOperation(function () { return getMyDriveInfo(options, officeComponentContext.inMockMode); }, function () {
        return readFromSimplePersistence({
            userId: identity.puid,
            collectionName: oneDriveInfoPersistenceKey,
            collectionVersion: oneDriveInfoPersistenceVersion,
            key: oneDriveInfoPersistenceKey,
        });
    }, function (networkPayload) {
        return writeToSimplePersistence({
            userId: identity.puid,
            collectionName: oneDriveInfoPersistenceKey,
            collectionVersion: oneDriveInfoPersistenceVersion,
            key: oneDriveInfoPersistenceKey,
            data: networkPayload,
        });
    }, handleRevalidation);
}
//# sourceMappingURL=executeMyDriveInfoDataFlow.js.map